module.exports = __webpack_public_path__ + "media/images/icon-svg/search-9f1ee5059eba7177cc81803f9c7d6679.svg";